import React from 'react';
import styled from 'styled-components';

// --- TYPE DEFINITIONS ---

interface Tab {
    id: string;
    label: string;
}

interface TabsProps {
    tabs: Tab[];
    activeTab: string;
    onTabClick: (tabId: string) => void;
}

// --- STYLED COMPONENTS ---

const TabsContainer = styled.div`
  display: flex;
  overflow-x: auto;
  gap: 12px;
  padding: 4px;
  margin-bottom: 24px;
  -webkit-overflow-scrolling: touch;

  /* --- MODIFIED: Improved cross-browser scrollbar hiding --- */
  scrollbar-width: none; /* For Firefox */
  -ms-overflow-style: none;  /* For Internet Explorer and Edge */
  &::-webkit-scrollbar {
    display: none; /* For Chrome, Safari, and Opera */
  }

  /* --- MODIFIED: Add media query for responsive centering --- 
    On screens 768px and wider (tablets, desktops), center the tabs.
    On smaller screens, the default left-alignment is maintained, allowing for scrolling.
  */
  @media (min-width: 768px) {
    justify-content: center;
  }
`;

const TabItem = styled.button<{ isActive: boolean }>`
  padding: 10px 20px;
  font-size: 0.95rem;
  font-weight: 600;
  border-radius: 9999px;
  border: 1.5px solid ${props => props.isActive ? '#c51d1dff' : '#D1D5DB'};
  background-color: ${props => props.isActive ? '#c51d1dff' : 'transparent'};
  color: ${props => props.isActive ? '#FFFFFF' : '#4B5563'};
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  white-space: nowrap;

  &:hover {
    background-color: ${props => props.isActive ? '#c51d1dff' : '#F3F4F6'};
  }
`;



const Tabs: React.FC<TabsProps> = ({ tabs, activeTab, onTabClick }) => {
    return (
        <TabsContainer>
            {tabs.map((tab) => (
                <TabItem
                    key={tab.id}
                    isActive={activeTab === tab.id}
                    onClick={() => onTabClick(tab.id)}
                >
                    {tab.label}
                </TabItem>
            ))}
        </TabsContainer>
    );
};

export default Tabs;